module.exports = __webpack_public_path__ + "img/microneedling-treatment-desktop-ru.6bb3c671.jpg";